import productCouponFromComponent from './index.vue';
var productCouponFrom = {};
productCouponFrom.install = function (Vue, options) {
  var ToastConstructor = Vue.extend(productCouponFromComponent);
  // 生成一个该子类的实例
  var instance = new ToastConstructor();
  instance.$mount(document.createElement('div'));
  document.body.appendChild(instance.$el);
  Vue.prototype.$modalProductCoupon = function (callback) {
    var useType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    instance.visible = true;
    instance.callback = callback;
    instance.useType = useType;
  };
};
export default productCouponFrom;